import { IGcpAppDispatch } from "../../../redux/store";
import { IPilotRouteProps } from "../../../redux/modules/router/routes";
import { fetchLatestPrescan } from "../../../redux/modules/prescan/asyncActions";
import { loadFlightMarkers } from "../../../redux/modules/flightMarkers/flightMarkersAsyncActions";
import { fetchSite } from "../../../redux/modules/site/asyncActions";
import { enableAllVisibility } from "../../../redux/modules/ui/reducer";
import isFulfilled from "../../../modules/isFulfilled";

const userOpensPilotPage =
  ({ customerId, siteId }: IPilotRouteProps) =>
  async (dispatch: IGcpAppDispatch) => {
    /**
     * Fetch latest prescan
     */
    try {
      await dispatch(fetchLatestPrescan(customerId, siteId));
    } catch {
      // A site with no dated scan is fine here; the prescan is optional.
    }

    /**
     * Fetch flight markers
     */
    const flightMarkersAreFetched = await isFulfilled(
      dispatch(loadFlightMarkers(customerId, siteId)),
    );

    if (!flightMarkersAreFetched) {
      throw new Error("This site has no Flight Markers");
    }

    /**
     * Fetch site
     */
    await dispatch(fetchSite(customerId, siteId)).then(
      (site) => {
        if (!site.srs) {
          // TODO: log/alert scenario error
          throw new Error("No SRS Found for Flight Markers View Page");
        }
      },
      () => {
        // TODO: log/alert scenario error
        throw new Error("No Site found for Flight Markers View Page");
      },
    );

    dispatch(enableAllVisibility());
  };

export default userOpensPilotPage;
